const cluesData = {
    rows: 14,
    cols: 6,
    centerRow: 6,
    centralWord: "PARIGI",
    matrix: [
        [null, null, null, "B", null, "B"],
        [null, null, null, "A", null, "R"],
        [null, "A", null, "T", null, "I"],
        [null, "P", null, "T", null, "V"],
        [null, "N", null, "I", null, "I"],
        [null, "E", null, "T", null, "D"],
        ["P", "A", "R", "I", "G", "I"],
        ["R", null, "A", null, "L", null],
        ["O", null, "C", null, "A", null],
        ["P", null, "H", null, "S", null],
        ["O", null, "I", null, "G", null],
        ["F", null, "D", null, "O", null],
        ["O", null, "E", null, "W", null],
        ["L", null, null, null, null, null],
    ],
    words: [
        {clueNumber: 1, answer: "PROPOFOL", col: 0, startRow: 6, length: 8, direction: "down", clue: "Anestetico endovenoso ad azione rapida, il più usato per l'induzione"},
        {clueNumber: 2, answer: "APNEA", col: 1, startRow: 2, length: 5, direction: "up", clue: "Interruzione del respiro, da monitorare attentamente in sedazione profonda"},
        {clueNumber: 3, answer: "RACHIDE", col: 2, startRow: 6, length: 7, direction: "down", clue: "Colonna vertebrale, sede dell'anestesia spinale ed epidurale"},
        {clueNumber: 4, answer: "BATTITI", col: 3, startRow: 0, length: 7, direction: "up", clue: "Le pulsazioni cardiache sotto costante monitoraggio in sala operatoria"},
        {clueNumber: 5, answer: "GLASGOW", col: 4, startRow: 6, length: 7, direction: "down", clue: "La scala che valuta il livello di coscienza dopo un trauma cranico"},
        {clueNumber: 6, answer: "BRIVIDI", col: 5, startRow: 0, length: 7, direction: "up", clue: "Tremori post-operatori legati all'ipotermia da anestesia"},
    ],
};

export default cluesData;
